// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mW0e","left":"styles_left__1sfq3"};